export default {
  'paymentGateway.title': '支付网关列表',
  'paymentGateway.form.type': '类型',
  'paymentGateway.form.type.placeholder': '请选择类型',
  'paymentGateway.form.search': '查询',
  'paymentGateway.form.reset': '重置',
  'paymentGateway.operation.add': '新增',
  'paymentGateway.operation.delete': '删除',
  'paymentGateway.operation.edit': '编辑',
  'paymentGateway.operation.batchDelete': '批量删除',
  'paymentGateway.operation.batchDeleteConfirm': '确定要删除选中的支付网关吗？',
  'paymentGateway.form.status': '账号状态',
  'paymentGateway.form.status.placeholder': '请选择账号状态',
  'paymentGateway.columns.status': '账号状态',
  'paymentGateway.status.normal': '正常',
  'paymentGateway.status.disabled': '禁用',
  'paymentGateway.status.suspended': '暂停',
  'paymentGateway.columns.merchantName': '商户名称',
  'paymentGateway.columns.type': '类型',
  'paymentGateway.columns.alias': '别名',
  'paymentGateway.columns.gatewayType': '网关类型',
  'paymentGateway.columns.paymentMethod': '支付方式',
  'paymentGateway.columns.rotationRatio': '轮转比例',
  'paymentGateway.columns.tdsOptions': '3DS选项',
  'paymentGateway.columns.createdAt': '创建时间',
  'paymentGateway.columns.updatedAt': '更新时间',
  'paymentGateway.columns.operations': '操作',
  'paymentGateway.columns.operations.view': '查看',
  'paymentGateway.modal.view': '查看网关',
  'paymentGateway.modal.close': '关闭',
  'paymentGateway.columns.operations.edit': '编辑',
  'paymentGateway.columns.operations.delete': '删除',
  'paymentGateway.columns.operations.deleteConfirm': '确定要删除这条记录吗？',
  'paymentGateway.actions.refresh': '刷新',
  'paymentGateway.actions.density': '密度',
  'paymentGateway.actions.columnSetting': '列设置',
  'paymentGateway.size.mini': '迷你',
  'paymentGateway.size.small': '小',
  'paymentGateway.size.medium': '中',
  'paymentGateway.size.large': '大',
  'paymentGateway.type.paypal': 'Paypal',
  'paymentGateway.type.card': '信用卡',
  'paymentGateway.type.scard': '续费信用卡',
  'paymentGateway.type.additional': '本地支付',
  'paymentGateway.modal.add': '新增网关',
  'paymentGateway.modal.edit': '编辑网关',
  'paymentGateway.modal.createSuccess': '创建成功',
  'paymentGateway.modal.updateSuccess': '更新成功',
  'paymentGateway.modal.saveFailed': '保存失败',
  'paymentGateway.modal.merchantRequired': '请选择商户',
  'paymentGateway.operation.deleteSuccess': '删除成功',
  'paymentGateway.operation.deleteFailed': '删除失败',
  'paymentGateway.operation.batchDeleteSuccess': '批量删除成功',
  'paymentGateway.operation.batchDeleteFailed': '批量删除失败',
  'paymentGateway.operation.noSelection': '请先选择要删除的数据',
  'paymentGateway.verify.title': 'PayPal 配置校验',
  'paymentGateway.verify.button': '校验配置',
  'paymentGateway.verify.shopifyId': 'Shopify ID',
  'paymentGateway.verify.shopifyId.placeholder': '请输入 Shopify ID（不含 .myshopify.com）',
  'paymentGateway.verify.shopifyId.required': '请输入 Shopify ID 后再校验',
  'paymentGateway.verify.clientId.required': '请先填写 Client ID',
  'paymentGateway.verify.secretKey.required': '请先填写 Secret Key',
  'paymentGateway.verify.success': 'PayPal 配置校验通过，Client ID 与 Secret Key 有效。',
  'paymentGateway.verify.failed': 'PayPal 配置校验未通过',
  'paymentGateway.verify.failedHint':
    'PayPal 配置校验未通过，请检查 Client ID、Secret Key 及 Partner Id 是否正确。',
  'paymentGateway.verify.failedHintNoPartner':
    'PayPal 配置校验未通过，请检查 Client ID 与 Secret Key 是否正确。',
};
